<template>
    <div class="mdui-container mdui-text-left" id="main-content">
        <div class="words" v-for="(item, index) in items">
            <div class="fluid">
                <p class='num'>{{index+1}}.<a @click="play($event, index)" class='how_read'></a></p>
                <p class='japanese'>{{item.japanese}}</p>
                <p class='chinese'>{{item.chinese}}</p>
                <p class='romaji'>{{item.romaji}}</p>
            </div>
            <div class="my-divider"></div>
        </div>
        <audio id="myAudio" src="" hidden="hidden">
            Your browser does not support the element.
        </audio>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Word",
        data(){
            return{
                items :[],
                name: "",
            }
        },
        props:{
            host:{
                require: true,
                type: String,
            }
        },
        methods:{
            getData(){
                axios.get(this.host + 'get_words?sort='+this.$route.query.sort+'&uid='+this.$route.query.uid)
                    .then((response) =>{
                        let data = response.data;
                        this.name = data.name;
                        this.$emit("titleChanged", this.name);
                        // console.log(response.data);
                        this.items = this.items.concat(data.data);
                        // console.log(this.items);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            play(e, index){
                // console.log(e);
                let audio = document.getElementById("myAudio");
                // console.log(this.items[index].url);
                audio.src = this.items[index].url;
                e.srcElement.classList.add("mp3_play");
                audio.play();

                let t1 = window.setTimeout(function(){//定时器
                    e.srcElement.classList.remove("mp3_play");
                }, 1800);
            },
        },
        beforeMount(){
            this.getData();
        },
        mounted() {
            // this.$emit("titleChanged", this.name);
        }
    }
</script>

<style scoped>
    div h3{
        display: block;
        margin-top: 0;
        text-align:left;
        font-weight: bold;
        overflow: hidden;
        /*text-overflow: ellipsis;*/
        /*white-space: nowrap; //文本不换行，这样超出一行的部分被截取，显示...*/
    }
    p{
        margin-top: 0;
        text-align: center;
        -webkit-margin-before: 10rem;
        -webkit-margin-after: 10rem;
        -webkit-margin-start: 0;
        -webkit-margin-end: 0;
        overflow: hidden;
        /*text-overflow: ellipsis;*/
        /*white-space: nowrap; //文本不换行，这样超出一行的部分被截取，显示...*/
    }
    p.num{
        width: 4rem;
        margin: 1rem auto 0 0;
        font-size: 1.2rem;
        text-align:left;
    }
    p.japanese{
        font-weight: bold;
        font-size: 1.25rem;
        margin: 0 0;
        text-align:left;
    }
    p.chinese{
        margin: 0 0;
        text-align:left;
        color: #222222;
    }
    p.romaji{
        margin: 0 auto 1rem 0;
        text-align:left;
        color: #008577;
    }
    footer{
        text-align:center;
        height: auto;
        color: #bac1c8 ;
        display: block;
        padding: 0;
        background-color: #ffffff;
        box-sizing: border-box;
    }

    .my_center{
        text-align: center;
    }
    .words{
        width: 100%;
        margin: 0 auto 0 auto;
        box-shadow: 0 1px 3px rgba(34, 25, 25, 0.2);
    }
    .white{
        background: white;
    }
    .how_read{
        display: block;
        width: 32px;
        height: 21px;
        overflow: hidden;
        background: url("/static/img/voice.png") no-repeat;/*https://wx4.sinaimg.cn/large/006v2QkVgy1g1klo38j45j300s0170sh.jpg*/
        text-decoration: none;
        margin: 0 0;
        float: right;
        transform: translateX(0.25rem) translateY(0.18rem);
        cursor: pointer;
    }
    .mp3_play{
        background-position: 0 -22px;
    }
    .fluid{
        box-sizing: border-box;
        margin-right: auto;
        margin-left: auto;
        padding-left: 15px;
        padding-right: 15px;
        line-height: 1.429;
    }
    .fluid:before {
        content: " ";
        display: table;
    }
    .my-divider{
        display: block;
        height: 1px;
        background-color: rgba(241,241,249,1);
    }
</style>


// WEBPACK FOOTER //
// src/components/Word.vue